<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
                 @showImage="showImage"
                 :acceptDownload="2"
                 @dowloadImage="dowloadImage"
  >
  </c-search-form>
</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";

export default {
  name: 'log-management',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Check số product với user đăng ký MHBL Toán và Tiếng Anh",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phoneNumber",
          label: "Số điện thoại",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'message',
          text: 'Đăng kí MHBL',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumberMHBL',
          text: 'Số đăng kí MHBL',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'phoneNumber',
          text: 'Số đăng kí tài khoản',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
      ]
    }
  },
  methods: {

  },
  created() {
    this.searchUrl = "/kidAccountClass/searchPhoneMathMHBL?sortField=status,classId&";
  }

}
</script>
